module.exports = __webpack_public_path__ + "img/76787C_2F3031_A5A9B8_444446-256px.366affb2.png";